/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ContactDto } from "./ContactDto";
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
} from "./ContactDto";

/**
 *
 * @export
 * @interface UpdateDeviceGroupContactsRequest
 */
export interface UpdateDeviceGroupContactsRequest {
    /**
     *
     * @type {Array<ContactDto>}
     * @memberof UpdateDeviceGroupContactsRequest
     */
    contacts?: Array<ContactDto>;
}

/**
 * Check if a given object implements the UpdateDeviceGroupContactsRequest interface.
 */
export function instanceOfUpdateDeviceGroupContactsRequest(
    value: object,
): value is UpdateDeviceGroupContactsRequest {
    return true;
}

export function UpdateDeviceGroupContactsRequestFromJSON(
    json: any,
): UpdateDeviceGroupContactsRequest {
    return UpdateDeviceGroupContactsRequestFromJSONTyped(json, false);
}

export function UpdateDeviceGroupContactsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateDeviceGroupContactsRequest {
    if (json == null) {
        return json;
    }
    return {
        contacts:
            json["contacts"] == null
                ? undefined
                : (json["contacts"] as Array<any>).map(ContactDtoFromJSON),
    };
}

export function UpdateDeviceGroupContactsRequestToJSON(
    value?: UpdateDeviceGroupContactsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        contacts:
            value["contacts"] == null
                ? undefined
                : (value["contacts"] as Array<any>).map(ContactDtoToJSON),
    };
}
